const joinValues = (...values: string[]): string => values.join(' / ');

const hasTooltipParagraph = (cell: any, index: number): boolean =>
  Boolean(cell?.tooltip?.[index]?.paragraph);

const parseJsonArray = (arrayData: any): any[] => JSON.parse(arrayData);

const buildTableArray = (
  jsonObj: any[],
  parseCell: (cell: any, key: string, key2: string) => any[]
): any[] =>
  jsonObj.map((element) => {
    const newArrayData: any[] = [];
    const iter = element.table;

    for (const key in iter) {
      const myObjArray: any[] = [];

      for (const key2 in iter[key]) {
        myObjArray.push(...parseCell(iter[key][key2], key, key2));
      }

      newArrayData.push(myObjArray);
    }

    return { table: newArrayData };
  });

const parseAuditCell = (cell: any, key2: string): any[] => {
  if (key2 === '5') {
    const estIni = cell.tooltip[1].paragraph;
    const estFin = cell.tooltip[3].paragraph;

    return [{ text: joinValues(estIni, estFin) }];
  }

  if (key2 === '7') {
    const dates = cell.tooltip[1].paragraph;
    const observations = cell.tooltip[3].paragraph;
    const minutes = cell.tooltip[5].paragraph;

    return [{ text: joinValues(dates, observations, minutes) }];
  }

  return [cell];
};

const parseHomeTrainCell = (cell: any): any => {
  const train = cell.tooltip[1].paragraph;
  const estIni = cell.tooltip[3].paragraph;
  const estFin = cell.tooltip[5].paragraph;

  return { text: joinValues(train, estIni, estFin) };
};

const parseHomeInstructorCell = (cell: any): any => {
  const instructor = cell.text;

  if (cell?.tooltip !== undefined) {
    const observations = cell.tooltip[1].paragraph;

    return { text: joinValues(instructor, observations) };
  }

  return { text: instructor || '-' };
};

const parseHomeUserInfoCell = (cell: any): any[] => {
  if (cell?.tooltip !== undefined && cell?.text !== undefined) {
    const alumn = cell?.text || '';
    const observations = cell?.tooltip[1]?.paragraph || '';

    return [{ text: joinValues(alumn, observations) }];
  }

  return [];
};

const parseHomeCell = (
  cell: any,
  key2: string,
  canSeeUserInfo: boolean
): any[] => {
  const result: any[] = [];

  if (key2 === '6' && hasTooltipParagraph(cell, 3)) {
    result.push(parseHomeTrainCell(cell));
  }

  if (key2 === '5' && hasTooltipParagraph(cell, 3)) {
    result.push(parseHomeTrainCell(cell));
    return result;
  }

  if (key2 === '7') {
    result.push(parseHomeInstructorCell(cell));
    return result;
  }

  if (canSeeUserInfo && key2 === '8') {
    return parseHomeUserInfoCell(cell);
  }

  result.push(cell);
  return result;
};

const parseReportHoursCell = (cell: any, key: string, key2: string): any[] => {
  if (key2 === '5' && Object.prototype.hasOwnProperty.call(cell, 'tooltip')) {
    const par = cell.tooltip[1].paragraph;

    return [
      cell,
      {
        text: par,
        className: 'position_icon test-class-name',
      },
    ];
  }

  if (key === '5') {
    return [
      cell,
      {
        text: 'No hay días con exceso',
      },
    ];
  }

  return [cell];
};

export function parseArrayData(
  arrayData: any,
  isHome: boolean = false,
  canSeeUserInfo: boolean = false
) {
  const jsonObj = parseJsonArray(arrayData);

  const tableArrayData = buildTableArray(jsonObj, (cell, _key, key2) =>
    isHome
      ? parseHomeCell(cell, key2, canSeeUserInfo)
      : parseAuditCell(cell, key2)
  );

  return JSON.stringify(tableArrayData);
}

export function parseReportHoursData(arrayData: any) {
  const jsonObj = parseJsonArray(arrayData);

  const tableArrayData = buildTableArray(jsonObj, (cell, key, key2) =>
    parseReportHoursCell(cell, key, key2)
  );

  return JSON.stringify(tableArrayData);
}

export function instructorHoursHeaders(headers: any) {
  const newHeaders: any[] = [...headers];
  newHeaders.push({ text: 'Días con exceso en cálculo de jornada (8h)' });
  return newHeaders;
}
